import { useEffect } from 'react';
import { useFormContext, Controller, useFieldArray, FieldError } from 'react-hook-form';
import { FormControl, FormLabel, Grid, InputLabel, Select, MenuItem, IconButton, Button, FormHelperText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface NationalitiesProps {
  nationalities: string[];
}

export const Nationalities = ({ nationalities }: NationalitiesProps) => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: 'nationalities',
    control,
  });

  useEffect(() => {
    if (fields.length > 0) return;
    append('');
  }, []);

  return (
    <>
      <FormControl margin='normal' fullWidth>
        <FormLabel>Nationalities</FormLabel>
        {fields.map((field, idx) => (
          <Field key={field.id} nationalities={nationalities} idx={idx} onRemove={idx >= 1 ? () => remove(idx) : undefined} />
        ))}
      </FormControl>
      <Button onClick={() => append('')}>Add</Button>
    </>
  );
};

interface FieldProps {
  nationalities: string[];
  idx: number;
  onRemove?: () => void;
}

const Field = ({ nationalities, idx, onRemove }: FieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const hasError = !!(errors.nationalities as Record<number, FieldError>)?.[idx];

  return (
    <FormControl margin='normal' fullWidth error={hasError}>
      <Grid container alignItems='center' spacing={1}>
        <Grid item xs={11}>
          <InputLabel>Nationality *</InputLabel>
          <Controller
            name={`nationalities.${idx}`}
            control={control}
            rules={{ required: 'Nationality is required' }}
            render={({ field, fieldState: { error } }) => (
              <>
                <Select {...field} variant='standard' fullWidth value={field.value.toLowerCase()}>
                  {nationalities.map((nationality, index) => (
                    <MenuItem key={index} value={nationality}>
                      {nationality}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error>{error?.message}</FormHelperText>
              </>
            )}
          />
        </Grid>
        <Grid item xs={1}>
          {onRemove && (
            <IconButton onClick={onRemove} size='large'>
              <CloseIcon />
            </IconButton>
          )}
        </Grid>
      </Grid>
    </FormControl>
  );
};
